export default __webpack_public_path__ + "c2b928a8222f0666f5401cc19a3d038f.png";